<div>
	Chat messages:
	<div *ngFor="let message of messages">{{ message.date | date:'yyyy-MM-dd HH:mm:ss' }} {{ message.sender ? message.sender : 'System' }}: {{ message.text }}</div>
</div>
